import { render, staticRenderFns } from "./CardPersonnelInfo.vue?vue&type=template&id=d118d510&scoped=true&"
import script from "./CardPersonnelInfo.vue?vue&type=script&lang=js&"
export * from "./CardPersonnelInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardPersonnelInfo.vue?vue&type=style&index=0&id=d118d510&lang=scss&scoped=true&"
import style1 from "./CardPersonnelInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d118d510",
  null
  
)

export default component.exports